<template>
  <form @submit="createTerm($event)" autocomplete="off">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label for="category">
            Term Name
            <span
              class="invalid"
              v-if="veeErrors.first('termName') && !termForm.name.value"
            >
              - Field is required
            </span>
          </label>
          <input
            name="termName"
            type="text"
            autocomplete="off"
            v-model.trim="termForm.name.value"
            placeholder="Enter term name"
            class="form-control"
            v-validate="'required|max:100'"
            data-vv-as="term name"
          />
          <div
            v-if="veeErrors.first('termName') && termForm.name.value"
            class="invalid-feedback"
          >
            {{ veeErrors.first("termName") }}
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group calculation--dropdown">
              <label for="calculation">
                Unit of calculation
                <span class="invalid" v-if="termForm.calculatedBy.value == ''">
                  - Field is required
                </span>
              </label>
              <v-select
                :options="termForm.calculatedBy.options"
                v-model="termForm.calculatedBy.value"
                placeholder="Set unit of calculation"
              >
              </v-select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="category">
                Calculation Value
                <span class="invalid" v-if="termForm.calculatedValue.value < 1">
                  - Invalid integer value
                </span>
              </label>
              <div class="input-group calculation--wrapper">
                <div class="input-group-prepend calculation--btn">
                  <ActionButton
                    mode="outline"
                    style="margin-top:0; width: 40px; border: none;"
                    :color="'#232323'"
                    :theme="{ primary, secondary, event, danger }"
                    :disabled="termForm.calculatedValue.value <= 1"
                    label="&mdash;"
                    @customEvent="
                      () =>
                        termForm.calculatedValue.value > 1
                          ? (termForm.calculatedValue.value -= 1)
                          : 1
                    "
                  />
                </div>
                <input
                  name="category"
                  type="number"
                  autocomplete="off"
                  min="1"
                  v-model.number.trim="termForm.calculatedValue.value"
                  placeholder="Enter calculation value"
                  class="form-control form-control--value calculation--field"
                />
                <div class="input-group-append calculation--btn">
                  <ActionButton
                    mode="outline"
                    style="margin-top:0; width: 40px; border: none;"
                    :color="'#232323'"
                    :theme="{ primary, secondary, event, danger }"
                    label="+"
                    @customEvent="termForm.calculatedValue.value += 1"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Loop all forms that need switch element  -->
        <div class="row submit-row" v-for="(item, key) in termForm" :key="key">
          <template
            v-if="
              showFields.includes(key) &&
                item.attributes &&
                item.attributes.length >= 2
            "
          >
            <template
              v-if="key === 'isCalculated' && !termForm.hasEndDate.value"
            />
            <div class="col-12" v-else>
              <div class="form-group">
                <label for="">{{ item.attributes[1].label }}</label>
                <div class="col d-flex p-0 align-items-center mb-1">
                  <div
                    class="switch"
                    :class="{
                      active: item.value === true || item.value === 2,
                      disabled:
                        key !== 'status' &&
                        termForm.calculatedBy.value &&
                        termForm.calculatedBy.value.value !== 'hour'
                    }"
                    @click="handleSwitchClick([key, item])"
                  >
                    <div class="indicator"></div>
                  </div>
                  <div @click="handleSwitchClick([key, item])">
                    <span>{{
                      item.value == true || item.value == 2
                        ? "Active"
                        : "Inactive"
                    }}</span>
                  </div>
                </div>
                <div
                  v-if="item.attributes[2]"
                  class="desc"
                  v-html="item.attributes[2].desc"
                ></div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <ActionButton
          type="submit"
          :theme="{ primary, secondary, event, danger }"
          :label="modalName === 'add-term' ? 'Add' : 'Update'"
          style="width: auto; margin-left: auto;"
          :disabled="loader"
        />
      </div>
    </div>
  </form>
</template>

<script>
import axios from "@/helpers/axios";
import { socketSender } from "@/helpers/socket";

const ActionButton = () => import("@/components/ActionButton");

export default {
  name: "AddTerm",
  components: {
    ActionButton
  },
  props: {
    singleRecord: {
      type: Object,
      default: () => {}
    },
    link: {
      type: String,
      default: null
    },
    modalName: {
      type: String,
      default: "edit-term"
    }
  },
  data: () => ({
    showFields: [
      "name",
      "calculatedBy",
      "calculatedValue",
      "hasEndDate",
      "isCalculated",
      "status"
    ],
    termForm: {
      name: {
        value: null,
        attributes: [{ required: true }]
      },
      calculatedBy: {
        label: null,
        value: null,
        attributes: [{ required: true }],
        options: [
          { label: "Hour", value: "hour" },
          { label: "Day", value: "day" },
          { label: "Week", value: "week" },
          { label: "Month", value: "month" },
          { label: "Year", value: "year" }
        ]
      },
      calculatedValue: {
        value: 1,
        attributes: [{ required: true }]
      },
      hasStartDate: {
        value: true,
        attributes: [{ required: false }, { label: "Date and Time" }]
      },
      hasStartTime: {
        value: true,
        attributes: [{ required: false }, { label: "Has Start Time" }]
      },
      hasEndDate: {
        value: false,
        attributes: [
          { required: false },
          { label: "Date and Time" },
          {
            desc:
              "Toggle on Date and Time to allow users to book products for a specific time frame (i.e. Meeting Room)."
          }
        ]
      },
      hasEndTime: {
        value: false,
        attributes: [{ required: false }, { label: "Has End Time" }]
      },
      isCalculated: {
        value: true,
        attributes: [{ required: false }, { label: "Auto Calculate Date/Time" }]
      },
      status: {
        value: false,
        attributes: [{ required: false }, { label: "Status" }]
      }
    },
    editTermId: null,
    termName: null,
    address: null,
    apiOptions: {
      mode: "pagination",
      link: null
    },
    loader: false
  }),
  watch: {
    "termForm.calculatedBy.value": {
      handler(val) {
        if (!val || val === null || (val.value && val.value === "hour")) return;
        this.termForm.hasEndDate.value = true;
        this.termForm.isCalculated.value = true;
      }
    }
  },
  created() {
    this.editSelectedTerm();
  },
  methods: {
    editSelectedTerm() {
      if (this.singleRecord) {
        let singleRecord = this.singleRecord;
        let form = this.termForm;

        this.editTermId = singleRecord.id;
        this.isActive = singleRecord.status;

        Object.keys(form).map(el => {
          form[el].value = singleRecord[el];

          if (form[el].attributes.length == 2) {
            form[el].value = singleRecord[el];
            if (el == "status") {
              form[el].value = singleRecord[el] == 1 ? false : true;
            }
          } else if (form[el].options) {
            form[el].label = singleRecord[el];
            form[el].value = singleRecord[el];
            if (el == "calculatedBy") {
              form[el].value = this.termForm.calculatedBy.options.find(
                i => i.value === singleRecord[el]
              );
            }
          }
        });
      }
    },
    handleSwitchClick(col) {
      if (
        col[0] !== "status" &&
        this.termForm.calculatedBy.value &&
        this.termForm.calculatedBy.value.value !== "hour"
      ) {
        return;
      }

      this.termForm[col[0]].value = col[1].value == false ? true : false;
    },
    async createTerm(event) {
      this.loader = true;
      event.preventDefault();
      let formIsValid = true;
      let form = this.termForm;
      form.isCalculated.value =
        this.termForm.hasEndDate.value &&
        form.calculatedBy.value.value === "hour"
          ? form.isCalculated.value
          : form.calculatedBy.value.value !== "hour" || false;

      Object.keys(form).map(key => {
        let required = form[key].attributes.filter(o => o.required == true);

        if (
          required.length != 0 &&
          (form[key].value == "" || form[key].value == null)
        ) {
          form[key].value = "";
          this.termForm[key].isValid = false;
          return (formIsValid = false);
        }
      });

      try {
        if (formIsValid == false) {
          throw {
            type: "warning",
            title: "Warning",
            error: new Error("Please fill the required fields")
          };
        }
        if (form.name.value.length > 100) {
          throw {
            type: "error",
            title: "Warning",
            error: new Error(
              "You have reached the maximum limit of characters allowed"
            )
          };
        }
        // Arrange Form data for saving
        let formSave = {};
        Object.keys(form).map(el => {
          formSave[el] =
            form[el].value && form[el].value.label
              ? form[el].value.value
              : form[el].value;
          //  For active and inactive
          if (el == "status") {
            formSave[el] = form[el].value == false ? 1 : 2;
          }
        });

        if (this.editTermId) {
          // Update category
          await axios.patch("/terms/" + this.editTermId, formSave);
          this.$emit("close");
        } else {
          /**
           * SOCKET: Add Category
           */
          await socketSender(
            "updateLog",
            `${this.$store.getters.getFullUser} added new Term named ${formSave.name}`
          );
          // Insert new category
          await axios.post("/terms", formSave);
          this.$emit("close");
        }

        this.$store.dispatch("FETCH_COLLECTION_PER_PAGE", this.link);

        await this.$toastr.success("Your changes are saved", "Success");
        this.$emit("close");
      } catch (error) {
        const errType = error.type || "error";
        const errTitle = error.title || "Error";
        const errMsg = error.error.message || error.message;

        this.$toastr[errType](errMsg, errTitle);
      } finally {
        this.loader = false;
      }
    }
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ .selected-tag {
  text-transform: capitalize;
}

.input-group .btn {
  border-color: #e8e8e8;
  padding-bottom: 0;
  padding-top: 0;
}

.form-control {
  &--value {
    text-align: center;
  }
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.desc {
  color: #a1a1a1;
  font-size: 0.75rem;
  line-height: 1.5;
}

.calculation {
  &--wrapper {
    border: 1px solid rgb(204, 204, 204);
    border-radius: 5px;
  }
  &--btn {
    .btn {
      font-size: 20px;
      /deep/ &:disabled {
        background-color: transparent !important;
      }
    }
  }
  &--field {
    border: none !important;
  }
  &--dropdown {
    /deep/ .dropdown-toggle {
      border-color: rgb(204, 204, 204) !important;
      border-radius: 5px;
    }
  }
}
</style>
